import React from "react";
import { UserProvider } from "./context/UserContext";
import AppRoutes from "./routes/AppRoutes";
import { PosProvider } from "./context/PosContext.js";
import { ShoppingProvider } from "./context/ShoppingContext";

const App = () => {
  return (
    <UserProvider>
      <PosProvider>
        <ShoppingProvider>
          <AppRoutes />
        </ShoppingProvider>
      </PosProvider>
    </UserProvider>
  );
};

export default App;
